const ID = /^[A-Za-z0-9_.:-]{1,128}$/;
export function sanitizeTesting(data) {
    if (!data || typeof data !== 'object') return null;
    const planId = typeof data.planId === 'string' && ID.test(data.planId) && !data.planId.includes('..') ? data.planId : null;
    const runId = typeof data.runId === 'string' && ID.test(data.runId) && !data.runId.includes('..') ? data.runId : null;
    return planId || runId ? { planId, runId } : null;
}
